import { api } from '../../Controllers/api'

const requestMaterials = () => {
  return {
    type: 'REQUEST_MATERIALS',
    loading: true
  }
}

const receiveMaterials = data => {
  return {
    type: 'RECEIVE_MATERIALS',
    payload: { data },
    loading: false
  }
}

const getMaterials = isRefresh => {
  return dispatch => {
    if (!isRefresh) {
      dispatch(requestMaterials())
    }
    api.get(`materials`).then(({ data }) => {
      dispatch(receiveMaterials(data))
    })
  }
}

const toggleMaterialsModal = () => {
  return dispatch => {
    dispatch({
      type: 'TOGGLE_MATERIALS_MODAL'
    })
  }
}

export { getMaterials, toggleMaterialsModal }
